import { render, staticRenderFns } from "./MobileOnscreenKeyboard.vue?vue&type=template&id=b570eb18&"
import script from "./MobileOnscreenKeyboard.vue?vue&type=script&lang=js&"
export * from "./MobileOnscreenKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./MobileOnscreenKeyboard.vue?vue&type=style&index=0&id=b570eb18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports